import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';

const WelcomeModal = ({ isOpen, onClose, userName = "" }) => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  if (!isOpen) return null;

  const handleVideoLoad = () => {
    setIsVideoLoaded(true);
  };

  const handleClose = () => {
    // Clear the first-time login flag so it doesn't show again
    localStorage.removeItem("isFirstTimeLogin");
    if (onClose) onClose();
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm selection:bg-[#02B491]/30">
      <motion.div
        initial={{ opacity: 0, scale: 0.95, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.95, y: 20 }}
        className="bg-white w-full max-w-3xl max-h-[90vh] rounded-2xl shadow-xl flex flex-col"
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-100">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">
              Welcome to the top 1%{userName ? `, ${userName}` : ""}! 🎉
            </h2>
            <p className="text-sm text-gray-600 mt-1">
              Watch this quick intro to get started on your journey
            </p>
          </div>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 p-2 rounded-full transition-colors hover:bg-gray-100"
            aria-label="Close modal"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Video Content */}
        <div className="flex-1 p-6">
          <div className="relative w-full aspect-video bg-gray-100 rounded-xl overflow-hidden shadow-sm">
            {!isVideoLoaded && (
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="flex flex-col items-center gap-3">
                  <div className="w-12 h-12 border-4 border-[#02B491]/20 border-t-[#02B491] rounded-full animate-spin"></div>
                  <p className="text-sm text-gray-500">Loading video...</p>
                </div>
              </div>
            )}
            <iframe
              src="https://www.loom.com/embed/c7c9a233982b4d43a3139ad3d3f01f9c?sid=71eb1307-04aa-4afd-88a6-5587976be2db"
              className="w-full h-full rounded-xl"
              title="Welcome Video"
              frameBorder="0"
              allowFullScreen
              onLoad={handleVideoLoad}
              style={{ display: isVideoLoaded ? 'block' : 'none' }}
            />
          </div>
          

        </div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-100">
          <div className="flex justify-end">
            <button
              onClick={handleClose}
              className="px-6 py-3 bg-[#02B491] text-white rounded-lg hover:bg-[#029078] focus:ring-2 focus:ring-[#02B491]/50 transition-all text-sm font-medium shadow-sm hover:shadow"
            >
              Let's get started! 
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default WelcomeModal; 